"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getRelatedModelMap", {
    enumerable: true,
    get: function() {
        return getRelatedModelMap;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
async function processColumn(context, column, relatedModels, visitedColumns = new Set()) {
    // Prevent circular references
    if (visitedColumns.has(column.id)) {
        return;
    }
    visitedColumns.add(column.id);
    if (!relatedModels.has(column.fk_model_id)) {
        const model = await _models.Model.get(context, column.fk_model_id);
        await model.getColumns(context);
        relatedModels.set(column.fk_model_id, model);
    }
    // Handle Link/LTAR columns
    if (column.colOptions && (0, _nocodbsdk.isLinksOrLTAR)(column)) {
        // related model
        if (!relatedModels.has(column.colOptions.fk_related_model_id)) {
            const targetContext = _extends({}, context, {
                base_id: column.colOptions.fk_related_base_id || context.base_id
            });
            const relatedModel = await _models.Model.get(targetContext, column.colOptions.fk_related_model_id);
            await relatedModel.getColumns(targetContext);
            relatedModels.set(column.colOptions.fk_related_model_id, relatedModel);
        }
        // junction model for many-to-many
        if (column.colOptions.fk_mm_model_id && !relatedModels.has(column.colOptions.fk_mm_model_id)) {
            const targetContext = _extends({}, context, {
                base_id: column.colOptions.fk_mm_base_id || context.base_id
            });
            const relatedModel = await _models.Model.get(targetContext, column.colOptions.fk_mm_model_id);
            await relatedModel.getColumns(targetContext);
            relatedModels.set(column.colOptions.fk_mm_model_id, relatedModel);
        }
    } else if (column.uidt === _nocodbsdk.UITypes.Lookup) {
        const colOptions = await column.getColOptions(context);
        const relationColOpt = await colOptions.getRelationColumn(context).then((col)=>{
            var _ref;
            return (_ref = col == null ? void 0 : col.colOptions) != null ? _ref : col == null ? void 0 : col.getColOptions(context);
        });
        // related model
        if (!relatedModels.has(relationColOpt.fk_related_model_id)) {
            const targetContext = _extends({}, context, {
                base_id: relationColOpt.fk_related_base_id || context.base_id
            });
            const relatedModel = await _models.Model.get(targetContext, relationColOpt.fk_related_model_id);
            await relatedModel.getColumns(targetContext);
            relatedModels.set(relationColOpt.fk_related_model_id, relatedModel);
        }
        const { refContext } = relationColOpt.getRelContext(context);
        await processColumn(refContext, await (colOptions == null ? void 0 : colOptions.getLookupColumn(refContext)), relatedModels);
    }
}
async function getRelatedModelMap(context, table) {
    const relatedModels = new Map();
    await table.getColumns(context);
    relatedModels.set(table.id, table);
    for (const col of table.columns){
        await processColumn(context, col, relatedModels);
    }
    return relatedModels;
}
